// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */:host:not(.m-is-drop-active){background:#f2f2f2;border:solid 1px #ccc}:host.m-is-drop-active{background:#e6e6e6;border:dashed 3px rgba(0,0,0,.38)}.m-card-list{min-height:100%;overflow:hidden;display:block}:host.m-is-drop-active .m-card-list{visibility:hidden}`, "",{"version":3,"sources":["webpack://./packages/builder-sales/leads/components/lead-board/lead-board-container/lead-board-column/lead-board-column.component.scss"],"names":[],"mappings":"AAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAQA,6BACE,kBAAA,CACA,qBAAA,CAGF,uBACE,kBAAA,CACA,iCAAA,CAGF,aACE,eAAA,CACA,eAAA,CACA,aAAA,CAGF,oCACE,iBAAA","sourcesContent":["/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */\n\n@use \"theme/styles/settings\" as *;\n@use \"theme/styles/tools\" as *;\n\n:host:not(.m-is-drop-active) {\n  background: #f2f2f2;\n  border: solid 1px #ccc;\n}\n\n:host.m-is-drop-active {\n  background: #e6e6e6;\n  border: dashed 3px $black-38;\n}\n\n.m-card-list {\n  min-height: 100%;\n  overflow: hidden;\n  display: block;\n}\n\n:host.m-is-drop-active .m-card-list {\n  visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
